import { z } from 'zod';

export const uppercaseValidation = z
  .string()
  .regex(/[A-Z]/, 'The password must contain at least one uppercase letter.');

export const minLengthValidation = z
  .string()
  .min(8, 'The password must be at least 8 characters long.');

export const lowercaseValidation = z
  .string()
  .regex(/[a-z]/, 'The password must contain at least one lowercase letter.');

export const digitValidation = z
  .string()
  .regex(/\d/, 'The password must contain at least one digit.');

export const specialCharValidation = z
  .string()
  .regex(/[\W_]/, 'The password must contain at least one special character.');
